var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 22,
    viewBox: "0 0 55 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa 1",
    clipPath: "url(#clip0_192_5076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0341 18.9679H19.7139L22.414 3.05149H26.7346L24.0341 18.9679ZM16.0795 3.05149L11.9609 13.9989L11.4735 11.6415L11.4739 11.6423L10.0203 4.48458C10.0203 4.48458 9.84448 3.05149 7.9709 3.05149H1.16193L1.08203 3.32099C1.08203 3.32099 3.16423 3.73653 5.60108 5.14024L9.35445 18.9683H13.8557L20.7291 3.05149H16.0795ZM50.06 18.9679H54.0269L50.5683 3.05107H47.0954C45.4917 3.05107 45.1011 4.23722 45.1011 4.23722L38.6579 18.9679H43.1614L44.062 16.6036H49.554L50.06 18.9679ZM45.3062 13.3377L47.5761 7.3814L48.8531 13.3377H45.3062ZM38.9957 6.87901L39.6122 3.46107C39.6122 3.46107 37.7098 2.76709 35.7266 2.76709C33.5827 2.76709 28.4915 3.66585 28.4915 8.03621C28.4915 12.1481 34.4669 12.1992 34.4669 14.3591C34.4669 16.5189 29.1071 16.1319 27.3383 14.7699L26.696 18.3437C26.696 18.3437 28.6251 19.2425 31.5724 19.2425C34.5206 19.2425 38.9682 17.7783 38.9682 13.7932C38.9682 9.65492 32.9391 9.26962 32.9391 7.47039C32.9395 5.67073 37.147 5.90191 38.9957 6.87901Z",
    fill: "#2566AF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4739 11.6416L10.0203 4.48387C10.0203 4.48387 9.84448 3.05078 7.9709 3.05078H1.16193L1.08203 3.32028C1.08203 3.32028 4.35469 3.97083 7.49374 6.40827C10.4952 8.73799 11.4739 11.6416 11.4739 11.6416Z",
    fill: "#E6A540"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_5076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.9,
    height: 22,
    fill: "white",
    transform: "translate(0.687744)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4861672352fd5b0830a0bfb0eef84b5e.svg";
export { ForwardRef as ReactComponent };